//#region types
import { DisplayType } from "models/enums/style";
import cssExports from "theme/styles/main.module.scss";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { ActionLinkButton, Icon } from "components/common";
import { useLocation, useNavigate } from "react-router-dom";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import clsx from "clsx";

const ReconciliationLink: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const onclick = () => {
    navigate(UrlHelper.formatPath(`/AdvisoryView/ReconciliationReport`), {
      state: { background: location },
    });
  };

  return (
    <ActionLinkButton
      className={clsx(cssExports.seeMoreLink, cssExports.animatedLink)}
      onClick={onclick}
      endIcon={<Icon icon={IconDefinitionConstants.WArrowSmallRight} displayType={DisplayType.Info} />}
    >
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ShowMore2)}
    </ActionLinkButton>
  );
};

export default ReconciliationLink;
